import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFirebase } from "../contexts/FirebaseContext";
import { useModal } from "../contexts/ModalContext";

const Home = () => {
	const { t } = useTranslation();
	const { writeDocument } = useFirebase();

	const [name, setName] = useState("");
	const [tel, setTel] = useState("");
	const [loading, setLoading] = useState(false);
	const [disableSubmit, setDisableSubmit] = useState(true);
	const { openModal, closeModal } = useModal();

	useEffect(() => {
		if (!name || !tel) {
			setDisableSubmit(true);
		} else {
			setDisableSubmit(false);
		}
	}, [name, tel]);

	const handleSubmit = async () => {
		try {
			setLoading(true);

			console.log(name, tel);
			const docId = await writeDocument("iqmRegistrations", {
				name,
				tel,
			});

			openModal(
				"Berjaya",
				<div className="text-green-600">
					<span>Terima kasih! Pendaftaran anda telah direkodkan.</span>
				</div>,
			);

			setName("");
			setTel("");
		} catch (error) {
			openModal(
				"Gagal",
				<div className="text-red-600">
					Gagal menghantar borang.
					<br />
					Sila cuba lagi.
					<br />
					<span className="text-xs">{error.message}</span>
				</div>,
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="flex flex-col p-2 sm:p-4 gap-4 justify-center items-center">
			<img
				className="w-full max-w-lg"
				alt="Ceramah Khas"
				src="/IQM_Ceramah-Khas-v2.jpeg"
			/>
			<div className="absolute py-4 px-12 justify-center items-center align-middle text-3xl text-red-600 bg-white/70 border-y-4 border-red-600 font-bold -rotate-6">
				PENDAFTARAN DITUTUP
			</div>
			{/* <div className="flex flex-col p-2 sm:p-4 gap-2 w-full max-w-lg bg-violet-50 border border-violet-950 rounded shadow shadow-violet-950/30">
				<span className="text-center font-bold text-violet-950">{t("registration.formTitle")}</span>

				<div className="flex flex-col">
					<div className="text-sm text-violet-950/70">{t("registration.name")}</div>
					<input
						type="text"
						className="p-1 rounded"
						placeholder="Ali bin Abu"
						value={name}
						onChange={(e) => setName(e.target.value)}
					/>
				</div>

				<div className="flex flex-col">
					<div className="text-sm text-violet-950/70">{t("registration.phone")}</div>
					<input
						type="text"
						className="p-1 rounded"
						placeholder="60123456789"
						value={tel}
						onChange={(e) => setTel(e.target.value)}
					/>
				</div>

				<button
					onClick={handleSubmit}
					disabled={loading || disableSubmit}
					type="button"
					className="p-2 bg-violet-950 hover:bg-violet-900 active:bg-violet-900 disabled:bg-violet-400 text-violet-50 rounded">
					{loading ? t("registration.submitting") : t("registration.submit")}
				</button>
			</div> */}
		</div>
	);
};

export default Home;
